<!-- 员工统计 -->
<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      style="margin-top:1vh;"
      width="800px"
      :close-on-click-modal="false"
    >
      <div slot="title" class="title">员工好友统计</div>
      <div class="table-container">
        <div class="btn-wrap">
          <el-tag
            class="select-stafft-wrap"
            title="选择员工"
            :closable="searchMenNames.length === 0 ? false : true"
            @close="searchCloseTag"
            type="medium"
            effect="plain"
            @click="clickAddMember()"
          >
            <span v-if="searchMenNames.length === 0">选择员工</span>
            <span
              class="staff-names"
              v-for="(item, index) in searchMenNames"
              :key="index"
              >{{ item.name
              }}<span
                v-show="
                  searchMenNames.length > 1 &&
                    index != searchMenNames.length - 1
                "
                >,</span
              ></span
            >
          </el-tag>
          <el-date-picker
            v-model="searchSelectTime"
            size="mini"
            :editable="false"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="selectTime"
            :picker-options="pickerOptions"
            clearable
            style="width: 240px;"
          >
          </el-date-picker>
        </div>
        <div class="table-data">
          <el-table
            v-loading="loading"
            size="medium"
            :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
            ref="singleTable"
            :highlight-current-row="true"
            :data="tableData"
            :default-sort="{ prop: 'bindDangAnCount', order: 'descending' }"
            @sort-change="customerSortChange"
            height="308px"
            style="width: 100%;height:100%;font-size: 13px"
          >
            <el-table-column
              show-overflow-tooltip
              prop="userName"
              label="员工姓名"
              width="118"
              align="left"
            ></el-table-column>
            <el-table-column
              prop="bindDangAnCount"
              label="绑定档案数"
              sortable="custom"
              min-width="102"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="bindCusCount"
              label="绑定客户数"
              sortable="custom"
              min-width="102"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="unbindDangAnCount"
              label="解绑次数"
              sortable="custom"
              min-width="102"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="friendNumb"
              label="好友总数"
              sortable="custom"
              min-width="102"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
        <el-pagination
          :background="true"
          @current-change="callBack"
          :current-page.sync="pageparm.currentPage"
          :page-size="pageparm.pageSize"
          layout="prev, pager, next, jumper"
          :total="pageparm.total"
        >
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 添加人员树 -->
    <!-- <AddMemberView title="选择成员" :dialogVisibleTree="dialogVisibleTree" :currentSelectMember='currentSelectMember' @closeTree='closeTree' @clickSubmitTree='clickSubmitTree'></AddMemberView> -->
    <StaffTree
      v-if="staffTreeShow"
      title="选择成员"
      :dialogVisibleTree="dialogVisibleTree"
      :currentSelectMember="currentSelectMember"
      @closeTree="closeTree"
      @clickSubmitTree="clickSubmitTree"
    ></StaffTree>
  </div>
</template>

<script>
import { getEmpCusDetail } from "@/api/dataStatistics/dataStatistics.js";
import AddMemberView from "@/views/code/components/addMember.vue";
import StaffTree from "@/components/staffTree/staffTree.vue";
export default {
  name: "customerStatistics",
  components: {
    // AddMemberView,
    StaffTree,
  },
  data() {
    return {
      dialogVisibleTree: false,
      currentSelectMember: [], // 当前选中的成员树
      dialogVisible: false,
      loading: false,
      searchMenNames: [],
      searchSelectTime: "", // 搜索----选中的时间段
      params: {
        userIdList: [], //员工userId数组【非必传】
        detailStartTime: "", //开始时间【非必传】
        detailEndTime: "", //结束时间【非必传】
        bindDangAnSort: "bindDangAnSortDesc", //绑定档案数排序【非必传】
        bindCusSort: "", //绑定客户数排序【非必传】
        unbindDangAnSort: "", //解绑档案数排序【非必传】
        friendNumbSort: "", //好友数排序【非必传】
        pageNum: 1, //页码【必传】
        pageSize: 10, //页数【必传】
      },
      pageparm: {
        urrentPage: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
      // 禁选时间
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          const oneDay = 1 * 24 * 3600 * 1000;
          const day = 180 * 24 * 3600 * 1000;
          return (
            time.getTime() >
              new Date(new Date().setHours(23, 59, 59, 999)).getTime() -
                8.64e7 || time.getTime() < curDate - day
          );
        },
      },
      /** 控制人员树组件树显示隐藏 */
      staffTreeShow:false,
    };
  },
  methods: {
    show() {
      this.dialogVisible = true;
      this.getTableData();
    },
    // 排序方式改变
    customerSortChange(val) {
      this.params.bindDangAnSort = "";
      this.params.bindCusSort = "";
      this.params.unbindDangAnSort = "";
      this.params.friendNumbSort = "";
      this.params.pageNum = 1;
      this.pageparm.currentPage = 1;
      switch (val.prop) {
        case "bindDangAnCount":
          // 绑定档案数
          this.params.bindDangAnSort =
            val.order == "descending"
              ? "bindDangAnSortDesc"
              : val.order == "ascending"
              ? "bindDangAnSortAsc"
              : "";
          break;
        case "bindCusCount":
          // 绑定客户数
          this.params.bindCusSort =
            val.order == "descending"
              ? "bindCusSortDesc"
              : val.order == "ascending"
              ? "bindCusSortAsc"
              : "";
          break;
        case "unbindDangAnCount":
          // 解绑档案数
          this.params.unbindDangAnSort =
            val.order == "descending"
              ? "unbindDangAnSortDesc"
              : val.order == "ascending"
              ? "unbindDangAnSortAsc"
              : "";
          break;
        case "friendNumb":
          // 好友总数
          this.params.friendNumbSort =
            val.order == "descending"
              ? "friendNumbSortDesc"
              : val.order == "ascending"
              ? "friendNumbSortAsc"
              : "";
          break;
      }
      this.getTableData();
    },
    // 搜索-添加成员
    clickAddMember() {
       /** 触发打开按钮，先渲染组件 */
      this.staffTreeShow = true;
      this.$nextTick(()=>{
        this.dialogVisibleTree = true;
      })
    },
    // 成员树的事件
    clickSubmitTree(val) {
      this.searchMenNames = [];
      this.currentSelectMember = val.currentMember;
      this.dialogVisibleTree = false;
      this.params.userIdList = [];
      val.sendArray.forEach((item) => {
        let obj = {
          userId: item.userId,
          name: item.userName,
        };
        this.searchMenNames.push(obj);
        this.params.userIdList.push(item.userId);
      });
      this.params.pageNum = 1;
      this.pageparm.currentPage = 1;
      // 发送请求
      this.getTableData();
    },
    // 树关闭
    closeTree(val) {
      this.dialogVisibleTree = false;
    },
    searchCloseTag() {
      this.searchMenNames = [];
      this.currentSelectMember = [];
      this.params.userIdList = [];
      this.getTableData();
    },
    // 选择时间处理
    selectTime(dataTime) {
      if (dataTime != null) {
        this.params.detailStartTime = dataTime[0];
        this.params.detailEndTime = dataTime[1];
      } else {
        this.params.detailStartTime = "";
        this.params.detailEndTime = "";
      }
      this.params.pageNum = 1;
      this.pageparm.currentPage = 1;
      this.getTableData();
    },
    callBack(parm) {
      this.params.pageNum = parm;
      this.getTableData();
    },
    // 获取表格数据
    getTableData() {
      this.loading = true;
      getEmpCusDetail(this.params, localStorage.getItem("Authorization"), true)
        .then((res) => {
          if (res.error.code == 200) {
            this.tableData = res.data.empCusBindDetail;
            this.pageparm.total = res.data.total;
            this.loading = false;
          } else {
            this.$message.error("获取表格数据失败，请重试！");
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error("获取表格数据失败，请重试！");
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
}
.table-container {
  .btn-wrap {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    /deep/.select-stafft-wrap {
      margin-right: 10px;
      width: 180px;
      position: relative;
      cursor: pointer;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      .el-icon-close {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 5px;
      }
      .staff-names {
        color: #606266;
      }
    }
    /deep/ .el-tag--plain {
      border-color: #dcdfe6;
      color: #c0c4cf;
    }
  }
  .table-data {
    margin-bottom: 16px;
    /deep/.el-table {
      display: flex;
      flex-direction: column;
      .el-table__body-wrapper {
        flex: 1 !important;
      }
    }
    /deep/.el-table__row .cell {
      padding: 10px 12px;
    }
    /deep/.el-table--medium th {
      padding: 10px 0;
    }
    /deep/ .el-table--medium td {
      padding: 0;
    }
  }
}
// /deep/.el-pagination {
//   .btn-prev,.btn-next {
//     background-color: white;
//     border: 1px solid #E6E9EB;
//   }
//   .el-pager  {
//     li {
//       background-color: white;
//       // border: 1px solid #2684FF;
//       color: rgba(0, 0, 0, 0.6);
//       border: 1px solid #E6E9EB;
//       border-radius: 2px;
//     }
//     li:not(.disabled).active {
//       border: 1px solid #2684FF;
//       color: #2684FF;
//       background-color: white;
//     }
//   }
// }
/deep/ .el-dialog__header {
  padding: 28px 28px 10px 32px;
}
/deep/ .el-dialog__body {
  padding: 14px 32px 6px;
  // 表格排序图标
  .el-table {
    .caret-wrapper {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      height: 22px;
      width: 24px;
      vertical-align: middle;
      cursor: pointer;
      overflow: initial;
      position: relative;
      .sort-caret {
        width: 0;
        height: 0;
        border: 3px solid transparent;
        position: absolute;
        left: 3px;
      }
      .ascending {
        border-bottom-color: #c0c4cc;
        top: 2px;
      }
      .descending {
        border-top-color: #c0c4cc;
        bottom: 5px;
      }
    }
    .descending .sort-caret.descending {
      border-top-color: #409eff;
    }
    .ascending .sort-caret.ascending {
      border-bottom-color: #409eff;
    }
  }
}
/deep/ .el-dialog__footer {
  padding: 4px 32px 32px;
  .el-button {
    width: 88px;
    height: 32px;
    padding: 0;
  }
}
</style>
